<div class="tag-wrapper">
  <core-icon *ngIf="icon" class="tag-icon" size="xs" [icon]="icon"></core-icon>
  <div class="tag-label">
    <ng-content></ng-content>
  </div>
  <core-icon *ngIf="interactive" class="ml-1" size="xs" [icon]="triggerIcon"></core-icon>
</div>
